module.exports = __webpack_public_path__ + "img/DN.064eab0a.png";